import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DialogProps, IconButton } from "@mui/material";
import React from "react";
import { useToggle } from "rooks";

import { InformativeModal } from "new-components/modals/InformativeModal";

interface TooltipModalButtonProps {
  modalTitle: string;
  modalContent: string;
  color?: string;
  size?: "small" | "medium" | "large";
  tooltipSize?: DialogProps["maxWidth"];
}

export function TooltipModalButton({
  modalTitle,
  modalContent,
  color = "white",
  size = "medium",
  tooltipSize = "md",
}: TooltipModalButtonProps) {
  const [open, toggle] = useToggle();

  return (
    <>
      <IconButton onClick={toggle} className="p-0" size={size}>
        <InfoOutlinedIcon className={`text-${color}`} fontSize={size} />
      </IconButton>

      {open && (
        <InformativeModal
          handleTooltipModalClose={toggle}
          isTooltipModalOpen={open}
          modalContent={modalContent}
          modalTitle={modalTitle}
          modalSize={tooltipSize}
        />
      )}
    </>
  );
}
